(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tec11-bot"] && !Shopify.designMode) return;
  try {
    function initTecBot(scope) {
  scope.querySelectorAll('[data-tec-bot]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const opener = root.querySelector('[data-tec-bot-open]');
    const dialog = root.querySelector('dialog');
    const frame = root.querySelector('iframe');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tec-bot-is-open');
    });
    root.querySelector('[data-tec-bot-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('tec-bot-is-open');
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    });
  });
}
initTecBot(document);
document.addEventListener('shopify:section:load', (event) => initTecBot(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  if (event.target.querySelector('[data-tec-bot]')) document.documentElement.classList.remove('tec-bot-is-open');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tec11-model-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){
  const select=event.target;
  if(!(select instanceof HTMLSelectElement)||!select.matches('[data-tec-model-filter]'))return;
  const destination=new URL(select.value,window.location.origin);
  if(destination.origin===window.location.origin)window.location.assign(destination.href);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tec11-pay-later"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tec11-pay-later')) {
    customElements.define('tec11-pay-later', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          if (!this.isConnected) return;
          const message = this.querySelector('[data-pp-message]');
          if (window.PayPalSDK?.Messages) {
            window.PayPalSDK.Messages({ pageType: 'product-details' }).render(message).catch(() => {});
          }
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
              message.setAttribute('data-pp-amount', (event.data.variant.price / 100).toFixed(2));
            });
          }
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.start();
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
